module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDY0MFY0NzIuNzlIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmMTA2MDAiIGQ9Ik0wIDBoNjQwdjE1Ny4zNzRIMHoiLz4KICAgIDxwYXRoIGQ9Ik0wIDMyMi42MjRoNjQwdjE1Ny4zNzRIMHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ye.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ye.svg
// module chunks = 0